export default "__VITE_ASSET__JyNfHiJu__"